<template>
  <b-list-group class="listGroup thin-scroll">
      <b-list-group-item class="listGroupItem" v-for="(notification,index) in notifications" :key="`${index}-${notification.NotificationID}`">
        <span class="notificationIcon thumb-sm">
          <img
            v-if="senderAvatar(notification)"
            class="rounded-circle"
            :src="senderAvatar(notification)"
            alt="Sender avatar"
            @error="onAvatarError"
          />
          <img v-else-if="notification.type === 'TASK_COMMENT'" class="rounded-circle" :src="defaultAvatar" alt="Sender avatar" />
          <img v-else-if="notification.type === 'YOUR_TASK'" class="rounded-circle" src="../../../assets/people/a3.jpg" alt="..." />
          <img v-else-if="notification.type === 'TASK'" class="rounded-circle" src="../../../assets/avatar.png" alt="..." />
          <i v-else-if="notification.type === 'BROKEN_APPOINTMENT'" class="fa fa-exclamation-circle " />
          <i v-else-if="notification.type === 'PROCESSED_PREAUTHS'" class="glyphicon glyphicon-ok-circle " />
          <i v-else-if="notification.type === 'PROCESSED_PREAUTHS_APPT_SCHEDULED'" class="glyphicon glyphicon-check " />
          <i v-else-if="notification.type === 'OUTSTANDING_PREAUTH_RECEIVED'" class="fa fa-archive" />
          <i v-else-if="notification.type === 'PROCESSED_PREAUTH_FOLLOWUP_TASK_CREATED'" class="glyphicon glyphicon-edit" />
          <i v-else-if="notification.type === 'OVERDUE_RECALL_APPT_SCHEDULED'" class="glyphicon glyphicon-check " />
          <i v-else-if="notification.type === 'UNSCHEDULED_APT_SCHEDULED'" class="glyphicon glyphicon-check " />
          <i v-else-if="notification.type === 'BROKEN_APPT_SCHEDULED'" class="glyphicon glyphicon-check " />
          <i v-else-if="notification.type === 'OUTSTANDING_CLAIM_RECEIVED'" class="fa fa-archive" />
          <i v-else-if="notification.type === 'PATIENT_BALANCE_PAIDOFF'" class="glyphicon glyphicon-check" />
          <i v-else-if="notification.type === 'PATIENT_MADE_PAYMENT'" class="glyphicon glyphicon-check" />
          <i v-else-if="notification.type === 'POST_OP_FOLLOWUP'" class="glyphicon glyphicon-check" />
          <i v-else class="fa fa-bell"></i>
        </span>
        <p class="m-0 overflow-hidden fs-mini">
            <span v-html="notification.text"/>
            <span class="badge mr-xs badge-success badge-pill" v-if="notification.type === 'PROCESSED_PREAUTHS'">Received PreAuths</span>
              <span class="badge mr-xs badge-success badge-pill mt-1" v-if="notification.type === 'PROCESSED_PREAUTHS_APPT_SCHEDULED'">Appointment Scheduled</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'PROCESSED_PREAUTHS_APPT_SCHEDULED'">Follow-up Purged</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'PROCESSED_PREAUTH_FOLLOWUP_TASK_CREATED'">Task Created</span>
              <span class="badge mr-xs badge-success badge-pill mt-1" v-if="notification.type === 'OUTSTANDING_PREAUTH_RECEIVED'">Pre-Auth Received</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'OUTSTANDING_PREAUTH_RECEIVED'">Follow-up Purged</span>
              <span class="badge mr-xs badge-success badge-pill mt-1" v-if="notification.type === 'OVERDUE_RECALL_APPT_SCHEDULED'">Recall Appt Scheduled</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'OVERDUE_RECALL_APPT_SCHEDULED'">Follow-up Purged</span>
              <span class="badge mr-xs badge-success badge-pill mt-1" v-if="notification.type === 'UNSCHEDULED_APT_SCHEDULED'">Unscheduled tx Appt Scheduled</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'UNSCHEDULED_APT_SCHEDULED'">Follow-up Purged</span>
              <span class="badge mr-xs badge-success badge-pill mt-1" v-if="notification.type === 'BROKEN_APPT_SCHEDULED'">Appointment Scheduled</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'BROKEN_APPT_SCHEDULED'">Follow-up Purged</span>
              <span class="badge mr-xs badge-success badge-pill mt-1" v-if="notification.type === 'OUTSTANDING_CLAIM_RECEIVED'">Outstanding Claim Received</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1" v-if="notification.type === 'OUTSTANDING_CLAIM_RECEIVED'">Follow-up Purged</span>
              <span class="badge mr-xs badge-danger badge-pill mt-1"  v-if="notification.type === 'BROKEN_APPOINTMENT'">Broken Appointment</span>
             <span class="badge mr-xs badge-success badge-pill mt-1"  v-if="notification.type === 'PATIENT_BALANCE_PAIDOFF'">Patient Balance Paid Off</span>
              <span class="badge mr-xs badge-success badge-pill mt-1"  v-if="notification.type === 'PATIENT_MADE_PAYMENT'">Payment Made</span>
              <span class="badge mr-xs badge-secondary badge-pill mt-1"  v-if="notification.type === 'POST_OP_FOLLOWUP'">Post-op Follow-up</span>
          
          <time class="help-block m-0 text-muted mt-1 fs-mini">
            {{notification.createdAt | dateformatwithtime}}
          </time>
        </p>
      </b-list-group-item>
    <!--
    <b-list-group-item class="listGroupItem">
      <span class="notificationIcon thumb-sm">
        <i class="fa fa-angle-double-up fa-2x" />
      </span>
      <p class="text-ellipsis m-0">
        2.1.0-pre-alpha just released.
        <time class="help-block m-0">
          5h ago
        </time>
      </p>
    </b-list-group-item>
    <b-list-group-item class="listGroupItem">
      <span class="notificationIcon thumb-sm">
        <i class="fa fa-bolt fa-lg" />
      </span>
      <p class="text-ellipsis m-0 overflow-hidden">
        Server load limited.
        <time class="help-block m-0">
          7h ago
        </time>
      </p>
    </b-list-group-item>
    <b-list-group-item class="listGroupItem">
      <span class="notificationIcon thumb-sm">
        <img class="rounded-circle" src="../../../assets/people/a5.jpg" alt="..." />
      </span>
      <p class="m-0 overflow-hidden">
        User <a href="#">Jeff</a> registered
        &nbsp;&nbsp;
        <b-button size="xs" variant="success" class="mr-1">Allow</b-button>
        <b-button size="xs" variant="danger">Deny</b-button>
        <time class="help-block m-0">
          12:18 AM
        </time>
      </p>
    </b-list-group-item>
    <b-list-group-item class="listGroupItem">
      <span class="notificationIcon thumb-sm">
        <i class="fa fa-shield fa-lg" />
      </span>
      <p class="m-0 overflow-hidden">
        Instructions for changing your Envato Account password. Please
        check your account <a href="#">security page</a>.
        <time class="help-block m-0">
          12:18 AM
        </time>
      </p>
    </b-list-group-item>
    <b-list-group-item class="listGroupItem">
      <span class="notificationIcon thumb-sm">
        <span class="rounded bg-primary rounded-lg">
          <i class="fa fa-facebook text-white" />
        </span>
      </span>
      <p class="text-ellipsis m-0">
        New <strong>76</strong> facebook likes received.
        <time class="help-block m-0">
          15 Apr 2014
        </time>
      </p>
    </b-list-group-item>
    <b-list-group-item class="listGroupItem">
      <span class="notificationIcon thumb-sm">
        <span class="circle circle-lg bg-gray-dark">
          <i class="fa fa-circle-o text-white" />
        </span>
      </span>
      <p class="text-ellipsis m-0">
        Dark matter detected.
        <time class="help-block m-0">
          15 Apr 2014
        </time>
      </p>
    </b-list-group-item>
    -->
  </b-list-group>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';
import defaultAvatar from '@/assets/avatar.png';
import { cleanAvatarUrl } from '@/utils/avatarUrl';

export default {
  name: 'NotificationsList',
  data() {
    return {
      defaultAvatar,
    }
  },
  methods: {
    // Notifications already in Firestore can carry the string "null" — clean at render too.
    senderAvatar(notification) {
      return cleanAvatarUrl(notification.senderAvatarUrl);
    },
    // Well-formed but dead URL (e.g. an expired Google photo) → default avatar, once.
    onAvatarError(e) {
      if (e.target.dataset.fallback) return;
      e.target.dataset.fallback = '1';
      e.target.src = defaultAvatar;
    },
  },
  computed: {
    ...mapGetters({
      allMyTasksDueToday: "tasks/allMyTasksDueToday",
      notificationsLastCleared: "notifications/lastCleared",
    }),
    ...mapState({
        notifications: state => state.notifications.notifications,
        userID: state => state.customer.userID,
        siteID: state => state.customer.siteID,
        settings: state => state.customer.settings,
    }),

    allSettings() {
      if(this.settings)
        return _.keyBy(this.settings, 'Property');
    }    
  }
};
</script>

<style src="./ListGroup.scss" lang="scss" />
